import { Armchair, MapPin, ShieldCheck, Swords, Target, Users } from "lucide-react";
import { useLang } from "./LangContext";
import { ChapterHead, FadeUp } from "./Reveal";

const ICONS = {
  target: Target,
  swords: Swords,
  users: Users,
  pin: MapPin,
  armchair: Armchair,
  shield: ShieldCheck,
};

export default function WhyMDR() {
  const { t } = useLang();
  const w = t.why;

  return (
    <section id="neden" className="section" data-testid="why-section">
      <div className="wrap">
        <ChapterHead num={w.num} label={w.label} title={w.title} />
        <div className="why-grid">
          {w.cards.map((card, i) => {
            const Icon = ICONS[card.icon];
            return (
              <FadeUp key={card.title} delay={(i % 3) * 0.08} className="why-cell">
                <div className="why-card" data-testid={`why-card-${i}`}>
                  <div className="icon-chip" aria-hidden="true">
                    <Icon size={21} strokeWidth={2} />
                  </div>
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
